export default "__VITE_ASSET__nbcz$_KD__"